var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfronto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43103 6.77586L1.5 4.13793M1.5 4.13793L4.43103 1.5M1.5 4.13793L14.9828 4.13794C16.9253 4.13794 18.5 5.71267 18.5 7.65518V9.1207M15.569 18.5L18.5001 15.8621M18.5001 15.8621L15.569 13.2241M18.5001 15.8621L5.01724 15.8621C3.07473 15.8621 1.5 14.2874 1.5 12.3448V10.8793",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfronto);
export default __webpack_public_path__ + "static/media/confronto.47d717f831ecdad7491f7c514b9e5cd9.svg";
export { ForwardRef as ReactComponent };